import React from 'react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  label: string;
  position: string;
  className?: string;
}
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function CTAButton({
  label,
  position,
  className = ''
}: CTAButtonProps) {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <a href={href} onClick={() => trackCTAClick(label, position)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-2 bg-forest-green hover:bg-forest-green/90 text-white text-lg font-bold py-4 px-8 rounded-full transition-all hover:scale-105 shadow-lg hover:shadow-xl w-full md:w-auto text-center ${className}`} data-id="element-14">
      {label}
      <ArrowRight size={20} data-id="element-15" />
    </a>;
}